import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { } from 'react-router-dom';
import { compose } from 'redux';
import {
  LayoutWrapperMain,
  Page,
  SubAdminManagement,
} from '../../components';
import config from '../../config';
import './subadminmanagement.global.scss';

interface Props {
  intl: any;
  scrollingDisabled: any;
}

const SubAdminManagementComponent: React.FC<Props> = (props: Props) => {
  const { intl, scrollingDisabled } = props;
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'SubAdminmanagement.page.title' },
    { siteTitle },
  );
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutWrapperMain className="layoutWrapperMain">
        <div className="content">
          <SubAdminManagement />
        </div>
      </LayoutWrapperMain>
    </Page>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

const SubAdminManagementComponentPage = compose(

  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(SubAdminManagementComponent);

export default SubAdminManagementComponentPage;
